import qs from "qs";
import { api } from "shared/api";
import { API_ROUTES, defaultOptions, baseURL } from "shared/api/consts";
import { ISupportType, SupportSendResponse } from "./models";

export const GetSupportList = async (user_id: number) => {
  const { data } = await api.post<ISupportType[]>(
    API_ROUTES.CONTACT_TYPES,
    qs.stringify({ ...defaultOptions(), user_id })
  );

  return data;
};

export const SupportSendApi = async (dto: any) => {
  const { data } = await api.post<SupportSendResponse>(
    API_ROUTES.CONTACT,
    dto,
    {
      baseURL,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return data;
};
